import { types } from '@/types';

const methodsWithoutError = [
  'fetchCustomerAccounts',
  'loadProfile',
  'signIn',
  'sendSMSCode',
  'signInSMSPhone',
  'registration',
  'getStatusReCaptcha',
];

const errorException = (e, commit, method) => {
  if (e.message.includes('null') || e.message.includes('not defined')) {
    !methodsWithoutError.includes(method) &&
      commit(
        types.ADD_ERROR,
        'Произошла ошибка, попробуйте позже или обратитесь в техподдержку',
      );
    console.error(`Error in method ${method}:\n`, e);
  } else if (!methodsWithoutError.includes(method))
    e.message && commit(types.ADD_ERROR, e.message);
};

export default errorException;
